import CuboIcon from '../icons/CuboIcon';

// An agent's permanent key. A real employee's email always has an `@`, so a key never collides.
const AGENT_PREFIX = 'agent_';

// The icon each agent shows next to its name. Cubo is `agent_expenses` on the backend.
const AGENT_ICONS = Object.freeze({
  agent_expenses: CuboIcon,
});

const reviewApproverTypeConstants = Object.freeze({
  ANY_ADMIN: 'any_admin',
  AUTO_APPROVAL: 'auto_approval'
});

const reviewStatusConstants = Object.freeze({
  APPROVED: 'approved',
  REJECTED: 'rejected',
  PENDING: 'pending',
  DEFAULT: 'default',
  AUTO_APPROVAL: 'auto-approval'
});

export {
  AGENT_ICONS,
  AGENT_PREFIX,
  reviewApproverTypeConstants,
  reviewStatusConstants,
};

